/* ──────────────────────────────────────────────────────────────────────────
   NJM Diwali add-ons — one-tap Diwali gifts under the cart items (2026-10-30, Vansh)
   Shows the SINGLE Diwali items at their normal price, in the cart drawer and on
   /cart, to everyone with something in the cart. Hampers are never offered (both
   Diwali Tables and the Duo).
   Bonbombs are Mumbai-only: their card shows only when the saved pincode is a
   Mumbai delivery pincode (same serviceable() rule as njm-cart-gate.js). No
   pincode, or a pincode outside Mumbai, means no Bonbombs card.
   Price, image and stock come from /products/<handle>.js, never hard-coded
   (the Chikki Pop banners drifted from the real price, 2026-08-20). A product
   already in the cart is skipped. Display-only until the shopper taps Add.
   Switch off: delete the njm-diwali-upsell.js script tag in
   snippets/halo-cart-sidebar.liquid and sections/main-cart.liquid.
   4 Nov (Vansh): Nut Bites and Royal Chivda are the pinned, bigger cards. Nut Bites
   carries the Shopify automatic discount "Diwali: ₹200 off Nut Bites" (BXGY, buy-basis
   = collection gift-threshold-basis, ends 8 Nov 23:59 IST). OFFER below only mirrors it:
   change one, change the other. The offer copy stops by itself at OFFER.ends.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__njmDiwaliInit) return;
  window.__njmDiwaliInit = true;

  // The two hero items first (4 Nov), then the rest as they were.
  var ITEMS = [
    { handle: 'diwali-nut-bites', hero: true, offer: true, pack: '4 pieces', sub: 'a nuttier mithai, no refined sugar', tag: 'Diwali special' },
    { handle: 'pass-the-chakna-royal-chivda', hero: true, pack: '5 pouches', sub: '50 g each, with dry fruits and nuts', tag: 'Diwali special' },
    { handle: 'cookie-coins', pack: '6 pieces', sub: 'dark chocolate cookies in a gift tin', tag: 'Freshly baked, back in stock!' },
    { handle: 'chikki-cards', pack: '6 Protein + 6 Superseed', sub: 'chikkis as playing cards' },
    { handle: 'bonbombs', variant: 67752787181699, pack: 'Box of 9', sub: 'protein bonbons, keep refrigerated', mumbaiOnly: true },
    { handle: 'one-more-round', sub: 'Our Diwali card game for the whole table' }
  ];
  var LS_KEYS = ['deliveryPincode', 'njm_pin'];
  var CACHE_KEY = 'njm_dw_products_v2';
  var CACHE_MS = 10 * 60 * 1000;
  var OFFER = { handle: 'diwali-nut-bites', off: 20000, min: 100000, ends: Date.parse('2026-11-08T23:59:59+05:30') };
  var products = null;
  var loading = null;
  var lastPin = null;
  var cart = null;
  var cartRows = null;
  var cartSeq = 0;
  var cartTimer = null;

  function serviceable(p) {
    if (!/^[1-9]\d{5}$/.test(p)) return false;
    var n = parseInt(p, 10);
    return (n >= 400001 && n <= 400104) || (n >= 400601 && n <= 400615) || (n >= 400701 && n <= 400710) ||
      (n >= 401101 && n <= 401107) || (n >= 410206 && n <= 410210) || n === 410218 || n === 410221;
  }
  function getPin() {
    for (var i = 0; i < LS_KEYS.length; i++) {
      var p = '';
      try { p = localStorage.getItem(LS_KEYS[i]) || ''; } catch (e) {}
      if (/^\d{6}$/.test(p)) return p;
    }
    return '';
  }
  var OFF_TXT = '₹' + (OFFER.off / 100);
  function money(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=280';
  }

  function loadProducts() {
    if (products) return Promise.resolve(products);
    if (loading) return loading;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < CACHE_MS) { products = c.p; return Promise.resolve(products); }
    } catch (e) {}
    loading = Promise.all(ITEMS.map(function (it) {
      return fetch('/products/' + it.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var p = {};
      list.forEach(function (prod, i) {
        var it = ITEMS[i], v = null;
        if (!prod) return;
        (prod.variants || []).forEach(function (x) {
          if (!v && (it.variant ? x.id === it.variant : x.available)) v = x;
        });
        if (!v || !v.available) return;
        p[it.handle] = { vid: v.id, name: it.name || prod.title, price: v.price, img: sized(prod.featured_image) };
      });
      products = p;
      loading = null;
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
      return p;
    });
    return loading;
  }

  // Where the strip goes: right under the item rows, in the drawer and on /cart.
  function targets() {
    var out = [];
    var d = document.querySelector('#halo-cart-sidebar .previewCartList');
    if (d && d.querySelector('li')) out.push({ list: d, page: false });
    var c = document.querySelector('#main-cart-items .cart-list');
    if (c && c.querySelector('a[href*="/products/"]')) out.push({ list: c, page: true });
    return out;
  }
  function handlesIn(list) {
    var seen = {};
    Array.prototype.forEach.call(list.querySelectorAll('a[href*="/products/"]'), function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) seen[m[1]] = true;
    });
    return seen;
  }

  // Mirrors the discount: what counts towards ₹1,000, and whether it has been reached.
  // No cart read yet, or the offer is over: null, so no card promises anything.
  function offerState() {
    if (!cart || !cart.items || Date.now() >= OFFER.ends) return null;
    // Tested on real carts 4 Nov: Nut Bites never count towards their own ₹1,000 (₹425 + Nut Bites and
    // 2 × Nut Bites get nothing). A second box sits on its own line at full price, so look at every line.
    var basis = 0, inCart = false, applied = false;
    cart.items.forEach(function (l) {
      if (l.handle === OFFER.handle) {
        inCart = true;
        if (l.original_line_price > l.final_line_price) applied = true;
        return;
      }
      var type = String(l.product_type || '').toLowerCase(), title = String(l.product_title || l.title || '').toLowerCase();
      if (type === 'digital gift card' || type === 'delivery' || title.indexOf('ice pack') !== -1 || !l.original_price) return;
      basis += l.original_line_price;
    });
    return {
      need: Math.max(0, OFFER.min - basis),
      inCart: inCart,
      applied: applied
    };
  }
  function offerLine(st) {
    if (st.need === 0) return OFF_TXT + ' off with your order';
    return 'Add ' + money(st.need) + ' more and get ' + OFF_TXT + ' off Nut Bites';
  }

  function card(it, p, st) {
    var img = it.hero ? 120 : 92;
    var deal = it.offer && st && st.need === 0;
    var shown = deal ? p.price - OFFER.off : p.price;
    return '<div class="njm-dw__item' + (it.hero ? ' njm-dw__item--hero' : '') + '" role="listitem">' +
      '<div class="njm-dw__pic"><img class="njm-dw__img" src="' + esc(p.img) + '" alt="" width="' + img + '" height="' + img + '" loading="lazy">' +
      (it.tag ? '<span class="njm-dw__tag">' + esc(it.tag) + '</span>' : it.mumbaiOnly ? '<span class="njm-dw__tag">Mumbai only</span>' : '') + '</div>' +
      '<div class="njm-dw__body">' +
      '<div class="njm-dw__nm">' + esc(p.name) + '</div>' +
      '<div class="njm-dw__sb">' + (it.pack ? '<b>' + esc(it.pack) + '</b> · ' : '') + esc(it.sub) + '</div>' +
      (it.offer && st ? '<div class="njm-dw__offer">' + esc(offerLine(st)) + '</div>' : '') +
      '<div class="njm-dw__foot"><span class="njm-dw__pr">' + money(shown) + (deal ? ' <s>' + money(p.price) + '</s>' : '') + '</span>' +
      '<button type="button" class="njm-dw__add" data-njm-dw-add="' + p.vid + '" data-handle="' + it.handle + '" data-price="' + shown + '"' +
      ' aria-label="Add ' + esc(p.name) + ' to your order, ' + money(shown) + '">+ Add</button></div>' +
      '</div></div>';
  }

  function render() {
    if (!products) return;
    var mumbai = serviceable(getPin());
    lastPin = getPin();
    var st = offerState();
    var note = '';
    if (st && st.inCart) {
      // Their Nut Bites are already in the cart: only the cart's own figures decide what this says.
      if (st.applied) note = OFF_TXT + ' off your Nut Bites is applied ✓';
      else if (st.need > 0) note = 'Add ' + money(st.need) + ' more and get ' + OFF_TXT + ' off your Nut Bites';
    }
    var stateSig = (st ? st.need + ':' + (st.inCart ? 1 : 0) + ':' + (st.applied ? 1 : 0) : '-') + ';';
    targets().forEach(function (t) {
      var inCart = handlesIn(t.list), cards = '', sig = stateSig;
      ITEMS.forEach(function (it) {
        var p = products[it.handle];
        if (!p || inCart[it.handle] || (it.offer && st && st.inCart) || (it.mumbaiOnly && !mumbai)) return;
        cards += card(it, p, st);
        sig += p.vid + ':' + p.price + ',';
      });
      var strip = t.list.nextElementSibling;
      if (!strip || !strip.hasAttribute('data-njm-dw')) strip = null;
      if (!cards && !note) { if (strip) strip.remove(); return; }
      if (strip && strip.getAttribute('data-sig') === sig) return;
      if (!strip) {
        strip = document.createElement('div');
        strip.className = 'njm-dw' + (t.page ? ' njm-dw--page' : '');
        strip.setAttribute('data-njm-dw', '');
        strip.setAttribute('role', 'region');
        strip.setAttribute('aria-label', 'Diwali gifts you can add');
        t.list.insertAdjacentElement('afterend', strip);
      }
      strip.setAttribute('data-sig', sig);
      strip.innerHTML = (note ? '<div class="njm-dw__note" role="status">' + esc(note) + '</div>' : '') +
        (cards ? '<div class="njm-dw__head">Add a Diwali gift</div><div class="njm-dw__list" role="list">' + cards + '</div>' : '');
    });
  }

  // The rows re-render on every cart change, so a change in their text is what asks for
  // a fresh /cart.js. Our own strip sits outside the rows and cannot retrigger this.
  function syncCart() {
    var rows = targets().map(function (t) { return t.list.textContent; }).join('|');
    if (cart && rows === cartRows) return;
    cartRows = rows;
    var seq = ++cartSeq;
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (seq !== cartSeq) return;
        if (!c) { cartRows = null; return; }
        cart = c;
        if (products) render();
      })
      .catch(function () { if (seq === cartSeq) cartRows = null; });
  }
  function refresh() {
    if (!targets().length) return;
    if (products) render(); else loadProducts().then(render).catch(function () {});
    clearTimeout(cartTimer);
    cartTimer = setTimeout(syncCart, 250);
  }

  function postJSON(url, body, tries) {
    tries = tries || 0;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) {
        if ((r.status === 429 || r.status >= 500) && tries < 4) {
          return new Promise(function (res) { setTimeout(res, 700 * (tries + 1)); }).then(function () { return postJSON(url, body, tries + 1); });
        }
        return r;
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-njm-dw-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    b.textContent = 'Adding…';
    var onPage = !!b.closest('#main-cart-items');
    postJSON('/cart/add.js', { items: [{ id: +b.getAttribute('data-njm-dw-add'), quantity: 1 }] })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); })
      .then(function () {
        b.textContent = 'Added ✓';
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'njm_diwali_addon', { item: b.getAttribute('data-handle'), value: +b.getAttribute('data-price') / 100, currency: 'INR' });
          }
        } catch (err) {}
        if (onPage) { location.reload(); return; }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
            window.sharedFunctions.updateSidebarCart(cart);
          }
        });
      })
      .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
  });

  var CSS = '.njm-dw{margin:18px 0 8px;color:#573016}' +
    '.njm-dw__head{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#c0653f;font-weight:800;margin:0 0 10px}' +
    '.njm-dw__list{display:flex;flex-direction:column;gap:8px}' +
    '.njm-dw__item{display:flex;gap:12px;align-items:stretch;background:#fff;border:1px solid #ecdfce;border-radius:12px;padding:8px}' +
    '.njm-dw__pic{position:relative;flex:0 0 92px;width:92px;height:92px}' +
    '.njm-dw__img{display:block;width:100%;height:100%;object-fit:cover;border-radius:9px;background:#f5eee1}' +
    '.njm-dw__body{flex:1 1 auto;min-width:0;display:flex;flex-direction:column}' +
    '.njm-dw__nm{font-weight:700;font-size:14px;line-height:1.25}' +
    '.njm-dw__tag{position:absolute;left:5px;bottom:5px;background:#573016;color:#fff;font-size:9.5px;font-weight:700;letter-spacing:.02em;padding:2px 7px;border-radius:999px;line-height:1.25;right:5px;text-align:center}' +
    '.njm-dw__sb{font-size:12px;line-height:1.35;color:#8a6f52;margin-top:3px}' +
    '.njm-dw__sb b{color:#573016;font-weight:700}' +
    '.njm-dw__foot{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:auto;padding-top:6px}' +
    '.njm-dw__pr{font-weight:800;font-size:15px}' +
    '.njm-dw__add{flex:0 0 auto;height:34px;padding:0 18px;border:0;border-radius:9px;background:#c0653f;color:#fff;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;white-space:nowrap}' +
    '.njm-dw__add:hover{background:#a8532f}' +
    '.njm-dw__add:focus-visible{outline:2px solid #573016;outline-offset:2px}' +
    '.njm-dw__add:disabled{opacity:.7;cursor:wait}' +
    '.njm-dw--page{margin:18px 0 6px}' +
    '.njm-dw__item--hero{gap:13px;padding:10px;background:#fff6e9;border:1.5px solid #c0653f;border-radius:14px}' +
    '.njm-dw__item--hero .njm-dw__pic{flex-basis:120px;width:120px;height:120px}' +
    ".njm-dw__item--hero .njm-dw__nm{font-family:'Agrandir','Arial Narrow',sans-serif;font-weight:700;font-size:17px;line-height:1.2;color:#3e2415}" +
    '.njm-dw__item--hero .njm-dw__sb{font-size:12.5px;color:#7a6047}' +
    '.njm-dw__item--hero .njm-dw__pr{font-size:18px}' +
    '.njm-dw__item--hero .njm-dw__pr s{font-size:13px;font-weight:500;color:#7a6047;margin-left:3px}' +
    '.njm-dw__item--hero .njm-dw__add{height:38px;padding:0 20px;font-size:14px}' +
    '.njm-dw__offer{margin-top:5px;font-size:12.5px;line-height:1.3;font-weight:700;color:#8f4424}' +
    '.njm-dw__note{margin:0 0 12px;padding:9px 12px;background:#fff6e9;border:1px solid #e7c9ae;border-radius:10px;font-size:13px;font-weight:700;line-height:1.3;color:#8f4424}';
  function injectCSS() {
    if (document.getElementById('njm-dw-css')) return;
    var s = document.createElement('style');
    s.id = 'njm-dw-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // The drawer and /cart re-render their rows on every cart change; put the list back each time.
  function watch(root) {
    if (!root || !window.MutationObserver) return;
    new MutationObserver(refresh).observe(root, { childList: true, subtree: true });
  }

  function init() {
    injectCSS();
    watch(document.getElementById('halo-cart-sidebar'));
    var page = document.getElementById('main-cart-items');
    watch(page && page.parentNode);
    refresh();
    // The pincode is saved by njm-cart-gate.js without a cart re-render; follow it so
    // the Bonbombs card appears or goes as soon as the pincode changes.
    setInterval(function () { if (products && getPin() !== lastPin) render(); }, 1200);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
